const { createContext } = require("react");

const CompanyDashboardContext = createContext({});

export default CompanyDashboardContext;
